import React from 'react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

interface PhoneNumberInputProps {
  value?: string | null;
  onChange: (value: string) => void;
  disabled: boolean;
  error?: boolean;
  label?: string;
  helperText?: string;
}

const MuiPhoneField = ({
  ref,
  ...props
}: Record<string, unknown> & { ref?: React.Ref<HTMLInputElement> }) => (
  <TextField {...props} inputRef={ref} variant='outlined' fullWidth />
);

export default function PhoneNumberInput({
  value,
  onChange,
  disabled,
  error,
  label,
  helperText,
}: PhoneNumberInputProps) {
  const { t } = useTranslation();

  return (
    <PhoneInput
      defaultCountry='AU'
      value={value ?? ''}
      onChange={(v) => onChange(v ?? '')}
      disabled={disabled}
      error={error}
      label={label ?? t('labels.phoneNumber')}
      helperText={helperText}
      inputComponent={MuiPhoneField}
    />
  );
}
